/*@flow*/
import isType from './isType';
import type { TypeT } from './types';

// return true if the type constructor behaves like the identity function
export default function isIdentity(type: TypeT<*>): %checks {
  return isType(type) ? type.meta.identity : true;
}
